import ApiService from '../../services/api.service.js';

export const state = {
  templates: [],
  requests: [],
  isLoadingTemplates: false,
  isLoadingRequests: false
};

export const mutations = {
  SET_TEMPLATES(state, data) {
    state.templates = data;
  },
  SET_REQUESTS(state, data) {
    state.requests = data;
  },
  SET_LOADING_TEMPLATES(state, val) {
    state.isLoadingTemplates = val;
  },
  SET_LOADING_REQUESTS(state, val) {
    state.isLoadingRequests = val;
  }
};

export const getters = {
  getTemplates: (state) => state.templates,
  getRequests: (state) => state.requests,
  isLoadingTemplates: (state) => state.isLoadingTemplates,
  isLoadingRequests: (state) => state.isLoadingRequests
};

export const actions = {
  async fetchTemplates({ commit }, query = {}) {
    commit('SET_LOADING_TEMPLATES', true);
    try {
      const params = Object.fromEntries(Object.entries(query).filter(([, v]) => v !== '' && v != null));
      const res = await ApiService.get('approval-workflow/templates?' + new URLSearchParams(params));
      if (res.status === 200) commit('SET_TEMPLATES', res.data);
    } catch (_) {
      // handled by ApiService interceptor
    } finally {
      commit('SET_LOADING_TEMPLATES', false);
    }
  },

  async fetchRequests({ commit }, query = {}) {
    commit('SET_LOADING_REQUESTS', true);
    try {
      const params = Object.fromEntries(Object.entries(query).filter(([, v]) => v !== '' && v != null));
      const res = await ApiService.get('approval-workflow/requests?' + new URLSearchParams(params));
      if (res.status === 200) commit('SET_REQUESTS', res.data);
    } catch (_) {
      // handled by ApiService interceptor
    } finally {
      commit('SET_LOADING_REQUESTS', false);
    }
  }
};
